import React from 'react';
import { Row, Col } from 'antd';
import { AddressProvider } from '../../model/provider';
import SelectStreet from '../SelectStreet/SelectStreet';
import SelectHouse from '../SelectHouse/SelectHouse';
import styles from './SelectAddress.module.scss';

const SelectAddress = () => {
  return (
    <AddressProvider>
      <Row>
        <Col span={12}>
          <SelectStreet className={styles.select} />
        </Col>
        <Col span={12}>
          <SelectHouse className={styles.select} />
        </Col>
      </Row>
    </AddressProvider>
  );
};

export default SelectAddress;
